import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import AutocompleteInput from './FormInputs/AutocompleteInput';

FormAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  options: PropTypes.array,
};

export default function FormAutocomplete({ fieldName, fieldAttributes, options }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{
        required: fieldAttributes?.validation?.required ?? undefined,
      }}
      render={() => <AutocompleteInput fieldAttributes={fieldAttributes} fieldName={fieldName} options={options} />}
    />
  );
}
